import { gql } from '@apollo/client';

export const CREATE_WATER_SUPPLIER = gql`
  mutation CreateWaterSupplier($input: WaterSupplierInput!) {
    createWaterSupplier(input: $input) {
      profileId
      acceptEmail
      reportName
      gracePeriod
      rpCheck2Type
      profile {
        id
        type
        name
        firstName
        lastName
        phones {
          id
          subType
          value
          extension
        }
        emails {
          id
          subType
          value
        }
        contactAddressId
        contactAddress {
          id
          street1
          street2
          city
          state
          zip
          zipExt
        }
        billingAddressId
        billingAddress {
          id
          street1
          street2
          city
          state
          zip
          zipExt
        }
      }
      user {
        email
      }
    }
  }
`;

export const UPDATE_WATER_SUPPLIER = gql`
  mutation UpdateWaterSupplier($id: ID!, $input: WaterSupplierInput!) {
    updateWaterSupplier(id: $id, input: $input) {
      profileId
      acceptEmail
      reportName
      gracePeriod
      rpCheck2Type
      profile {
        id
        type
        name
        firstName
        lastName
        phones {
          id
          subType
          value
          extension
        }
        emails {
          id
          subType
          value
        }
        contactAddressId
        contactAddress {
          id
          street1
          street2
          city
          state
          zip
          zipExt
        }
        billingAddressId
        billingAddress {
          id
          street1
          street2
          city
          state
          zip
          zipExt
        }
      }
    }
  }
`;
